import { Provider } from '@angular/core';

import { DEFAULT_FV_SIDEBAR_CONFIG, type FvSidebarConfig, provideFvSidebarConfig } from '@fv/ui-kit';

import { environment } from '@finverity/platform-app/env/environment';

import { provideNavigationSidebarMenuBottomSectionItems } from './bottom-section-items.provider';
import { provideNavigationMenuItems } from './menu-items.provider';

export function getNavigationSidebarProviders(config?: FvSidebarConfig): Provider[] {
  return [
    provideNavigationMenuItems(),
    provideNavigationSidebarMenuBottomSectionItems(),
    provideFvSidebarConfig({
      ...DEFAULT_FV_SIDEBAR_CONFIG,
      skipSidebarSubItemsLines: environment.platform.skipSidebarSubItemsLines,
      ...config,
    }),
  ];
}
